module.exports = __webpack_public_path__ + "static/media/7.fb0cd9ff.jpg";